import nuhLogo from './nuh.png';
import akcansaLogo from './akcansa.png';
/* SOCAR: Wikimedia Commons'taki resmi logo (Logo_of_SOCAR.svg, 09.10.2026).
   Vektör: rayda da raporda da keskin; precache glob'u svg'yi de kapsıyor. */
import socarLogo from './socar.svg';

/**
 * MÜŞTERİ MARKA VARLIKLARI.
 *
 * ⚠️ LOGO DOSYALARI REPODA, VERİTABANINDA DEĞİL. Veritabanında yalnız
 *    `Customer.kod` durur ve logo buradan eşlenir.
 *
 *    Gerekçe T1 (offline-first): MinIO'dan ya da bir URL'den gelen logo,
 *    sinyalsiz fabrikada YÜKLENMEZ — kullanıcı hangi şirkette olduğunu
 *    tam da bağlantının olmadığı yerde göremezdi. Buradan gelen dosya
 *    uygulama kabuğuyla birlikte precache edilir (vite.config.ts glob'u
 *    png ve svg içerir), yani çevrimdışı açılışta da görünür.
 *
 *    Bedeli: yeni müşteri eklemek bir deploy gerektirir. Kabul edilebilir —
 *    müşteri eklemek zaten ünite taksonomisi ve mail şablonu kararı
 *    gerektiren bir iş, kendi kendine olan bir şey değil.
 */

export interface MusteriMarka {
  logo: string;
  /** Logonun en/boy oranı — dar rayda kırpma kararı için. */
  genis: boolean;
}

const MARKALAR: Record<string, MusteriMarka> = {
  NUH: { logo: nuhLogo, genis: false },
  AKCANSA: { logo: akcansaLogo, genis: true },
  SOCAR: { logo: socarLogo, genis: true },
};

export function markaBul(kod: string): MusteriMarka | null {
  return MARKALAR[kod.toUpperCase()] ?? null;
}

/**
 * MÜŞTERİ LOGOSU — beyaz zemin ZORUNLU, dekorasyon değil.
 *
 * Ray lacivert (`--navy`). Akçansa'nın logosu koyu yeşil, Nuh'unki kısmen
 * açık mavi/beyaz: ikisi de kurumsal kılavuzunda beyaz zemin varsayıyor ve
 * doğrudan lacivere konduğunda biri okunmuyor, diğeri eriyor. Zemin
 * bileşenin İÇİNDE, çağıran tarafın hatırlamasına bırakılmadı.
 */
export function MusteriLogo({
  kod,
  ad,
  yukseklik = 'h-7',
  className = '',
}: {
  kod: string;
  ad: string;
  yukseklik?: string;
  className?: string;
}) {
  const marka = markaBul(kod);

  if (!marka) {
    // Logosu paketlenmemiş müşteri — isim baş harfleriyle. Bu dal ÇALIŞIR
    // durumda olmalı: yeni müşteri, logosu eklenmeden önce de sisteme girer.
    return (
      <span
        className={`flex ${yukseklik} items-center rounded-md bg-white px-2 text-xs font-bold text-navy ${className}`}
        title={ad}
      >
        {ad.slice(0, 12)}
      </span>
    );
  }

  return (
    <span className={`flex ${yukseklik} items-center rounded-md bg-white px-2 py-1 ${className}`}>
      <img src={marka.logo} alt={ad} className="h-full w-auto object-contain" />
    </span>
  );
}
